import React from "react";
import { Stack } from "@altimateai/lego";

export const PassAtKDisplay: React.FC<{
  passAtK: Record<string, number | null> | null | undefined;
}> = ({ passAtK }) => {
  if (!passAtK) return <span className="al-text-gray-400">-</span>;

  const entries = Object.entries(passAtK)
    .filter(([, v]) => v !== null)
    .sort(([a], [b]) => parseInt(a) - parseInt(b));

  if (entries.length === 0) return <span className="al-text-gray-400">-</span>;

  return (
    <Stack direction="row" gap="xs" className="al-flex-wrap">
      {entries.map(([k, v]) => (
        <span key={k} className="al-text-xs al-bg-gray-100 al-rounded al-px-1.5 al-py-0.5">
          @{k}: {((v as number) * 100).toFixed(0)}%
        </span>
      ))}
    </Stack>
  );
};
